module.exports = __webpack_public_path__ + "static/media/3.e27e4793.png";